export default __webpack_public_path__ + "static/media/Research-hover.ad62be6f.svg";